import { Component, inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { BottomsheetLayoutComponent } from '@components/bottomsheet-layout/bottomsheet-layout.component';
import { Catalog } from '@cureskin/api-client/src/server-api';
import { EventLoggerService } from '@services/event-logger-service';
import { getProductImage } from 'client/helper/product-helper';

@Component({
  selector: 'teenager-restriction-bottomsheet',
  imports: [ButtonCtaComponent, BottomsheetLayoutComponent],
  templateUrl: './teenager-restriction-bottomsheet.component.html',
})
export class TeenagerRestrictionBottomsheetComponent implements OnInit {
  private readonly eventLoggerService = inject(EventLoggerService);
  bottomSheetRef: MatBottomSheetRef<TeenagerRestrictionBottomsheetComponent> = inject(MatBottomSheetRef<TeenagerRestrictionBottomsheetComponent>);
  public readonly data: { product: Catalog } = inject(MAT_BOTTOM_SHEET_DATA);

  productImage: string | null = null;

  ngOnInit(): void {
    this.eventLoggerService.cleverTapEvent('impression', JSON.stringify({
      name: 'add_to_cart_teenager_bs',
    }));
    this.productImage = getProductImage(this.data.product);
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }
}
